import { useState } from 'react';
import { Trans } from '@lingui/react/macro';
import styles from './IntroducerOnboardingDE.module.css';
import { OnboardingFormDE } from './OnboardingFormDE/OnboardingFormDE';
import { QualificationGate } from './QualificationGate/QualificationGate';
import {
  getGateOutcome,
  TGateAnswers,
} from './QualificationGate/QualificationGate.helpers';

export const IntroducerOnboardingDE = () => {
  const [answers, setAnswers] = useState<TGateAnswers>({});
  const [isLocked, setIsLocked] = useState(false);

  const outcome = getGateOutcome(answers);
  const isEligible = outcome === 'broker' || outcome === 'partner';

  return (
    <div className={styles.container}>
      <h1 className={styles.heading}>
        <Trans>Create a partner profile</Trans>
      </h1>
      <p className={styles.intro}>
        <Trans>
          Is your company already a partner of ours? Ask your colleagues for an
          invite link to get started right away.
        </Trans>
      </p>
      <QualificationGate
        answers={answers}
        onChange={setAnswers}
        disabled={isLocked}
      />
      {isEligible && <OnboardingFormDE onConfirmingChange={setIsLocked} />}
    </div>
  );
};
